module.exports = __webpack_public_path__ + "f948a19c21399daeaf60823dece49a2e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/balloon.png
// module id = 2978
// module chunks = 0